var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 17.5C14.8333 17.5 13.0869 17.1006 11.3858 16.3017C9.68472 15.5028 8.17778 14.4472 6.865 13.135C5.55222 11.8228 4.49667 10.3158 3.69833 8.61417C2.9 6.9125 2.50056 5.16611 2.5 3.375C2.5 3.125 2.58333 2.91667 2.75 2.75C2.91667 2.58333 3.125 2.5 3.375 2.5H6.75C6.94444 2.5 7.11806 2.5625 7.27083 2.6875C7.42361 2.8125 7.51389 2.97222 7.54167 3.16667L8.08333 6.08333C8.11111 6.27778 8.1075 6.455 8.0725 6.615C8.0375 6.775 7.95778 6.91722 7.83333 7.04167L5.83333 9.08333C6.41667 10.0833 7.14583 11.0208 8.02083 11.8958C8.89583 12.7708 9.86111 13.5278 10.9167 14.1667L12.875 12.2083C13 12.0833 13.1633 11.9897 13.365 11.9275C13.5667 11.8653 13.7644 11.8478 13.9583 11.875L16.8333 12.4583C17.0278 12.5 17.1875 12.5939 17.3125 12.74C17.4375 12.8861 17.5 13.0561 17.5 13.25V16.625C17.5 16.875 17.4167 17.0833 17.25 17.25C17.0833 17.4167 16.875 17.5 16.625 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.4e33d513e75e60824eacc02c8ba1ab35.svg";
export { ForwardRef as ReactComponent };